// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3KZCa","inputDescription":"styles_inputDescription__2yPA7"};